import React from "react";
import { Card, CardContent, Typography, Box, IconButton } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function GlobalCard({
  children,
  onClick,
  hovershadowEffect,
  height,
  textAlign,
  padding,
  cursor,
background,
  ...props
}) {
  return (
    <>
      <Card
        onClick={onClick}
        sx={{
          borderRadius: 3,
          boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)", // soft shadow
          textAlign: textAlign ? textAlign : "left",
          "&:hover": hovershadowEffect
            ? { boxShadow: "0px 4px 12px rgba(0,0,0,0.3)" }
            : "",
          transition: "all 0.3s ease",
          cursor: cursor ? "pointer" : null,
          padding: padding ? padding : "20px",
          height: height ? height : null,
          background :background ? background :"white"
        }}
        {...props}
      >
        {children}
      </Card>
    </>
  );
}
